import script from "./FlexDataCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlexDataCheck.vue?vue&type=script&lang=ts&setup=true"

import "./FlexDataCheck.vue?vue&type=style&index=0&id=167ab7ee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167ab7ee"]])

export default __exports__